export const isBestDealsPath = (pathname: string) =>
  pathname === "/hot-deals" || pathname === "/featured-deals";
